// src/store/floatForm.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { FormProps } from '@/types/form'; // Asegúrate de tener este tipo definido

export const useFloatFormStore = defineStore('floatForm', () => {
  const isOpen = ref(false);
  const component = ref<string | null>(null);
  const formTitle = ref<string | null>(null);
  const formWidth = ref<number | string | null>(null);
  const module = ref<string | null>(null);
  const props = ref<FormProps | null>(null); // ✅ Tipado correctamente

  const openForm = (data: {
    module?: string;
    component?: string;
    formTitle?: string;
    formWidth?: number | string;
    props?: FormProps;
  } = {}) => {
    module.value = data.module || null;
    component.value = data.component || null;
    formTitle.value = data.formTitle || null;
    formWidth.value = data.formWidth || null;
    props.value = data.props || null;
    isOpen.value = true;
  };

  const closeForm = () => {
    isOpen.value = false;
    component.value = null;
    formTitle.value = null;
    formWidth.value = null;
    module.value = null;
    props.value = null;
  };

  const openFormWithPromise = <T extends Record<string, any>>(options: {
    module?: string;
    component: any;
    formTitle?: string;
    formWidth?: number | string;
    props?: Partial<T>; // 👈 los props que pasas no necesitan ser exactos
  }): Promise<T> => {
    return new Promise((resolve, reject) => {
      const wrappedProps: Record<string, any> = {
        ...(options.props || {}),
        onSubmit: (data: Record<string, any>) => {
          closeForm();
          resolve(data as T); // 👈 aquí haces el cast con confianza
        },
        onCancel: () => {
          closeForm();
          reject(new Error('Formulario cancelado'));
        },
      };
  
      openForm({
        module: options.module,
        component: options.component,
        formTitle: options.formTitle ?? '',
        formWidth: options.formWidth ?? '700',
        props: wrappedProps,
      });
    });
  };
  

  return {
    isOpen,
    openForm,
    closeForm,
    component,
    formTitle,
    formWidth,
    module,
    props,
    openFormWithPromise
  };
});
